/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAPIKeyRequest } from '../models/CreateAPIKeyRequest';
import type { CreateAPIKeyResponse } from '../models/CreateAPIKeyResponse';
import type { RevokeApiKeyResponse } from '../models/RevokeApiKeyResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TcnService {

    /**
     * Revokes the Zendesk access token on behalf of an user.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns RevokeApiKeyResponse OK
     * @throws ApiError
     */
    public static revokeApiKey(
        organizationId: string,
    ): CancelablePromise<RevokeApiKeyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/organizations/{organizationId}/tcn/revokeApiKey',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the TCN integration.
     * @param requestBody The request
     * @returns CreateAPIKeyResponse OK
     * @throws ApiError
     */
    public static createApiKey(
        requestBody?: CreateAPIKeyRequest,
    ): CancelablePromise<CreateAPIKeyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/tcn/createAPIKey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
